import React, { useEffect } from "react";

import Main from '../components/AboutUs/Main'
import AchieveMore from "../components/AboutUs/AchieveMore";
import GainComplete from "../components/AboutUs/GainComplete";
import YourData from "../components/AboutUs/YourData";
import WhatWeHave from "../components/AboutUs/WhatWeHave";
import SimpleSteps from "../components/Home/SimpleSteps";

function AboutUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1A1A28]">
            <Main/>
            <AchieveMore/>
            <GainComplete/>
            <YourData/>
            <WhatWeHave/>
            <SimpleSteps/>
        </div>
    );
}

export default AboutUs;